import React from 'react';

import styles from './PromoBox.scss';

const PromoBox = ({ type, logo, children }) => {
  return (
    <div className={`PromoBox PromoBox--${type}`}>
      <div className="PromoBox__logo">{logo}</div>
      <div className="PromoBox__content">{children}</div>
    </div>
  );
};

export default PromoBox;
